import { memo } from 'react';
import classNames from 'classnames';

import { getModels, useChildComponents } from '../../utils/use-child-components';

import { LogoContainerProps } from './logo-container.config';

const LogoContainer = memo(({ additionalClasses, cqPath, isInEditor, ...props }: LogoContainerProps) => {
  const childComponents = useChildComponents(
    cqPath,
    getModels({ cqPath, isInEditor, ...props }, ['logo_content_container']),
    {
      isInEditor,
    }
  );

  return (
    <div className={classNames('snowflake-logo-container', additionalClasses)} data-testid="snowflake-logo-container">
      {childComponents?.logo_content_container}
    </div>
  );
});

LogoContainer.displayName = 'LogoContainer';

export default LogoContainer;
